import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroup} from '../../shared/models/routeGroup.model';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../authentication/authentication.service';
import {groupBy, mergeMap, toArray, takeUntil} from 'rxjs/operators';
import {from, Subject} from 'rxjs';

@Component({
    selector: 'form-list-confirmed-change-date',
    templateUrl: 'form-list-confirmed-change-date.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormListConfirmedChangeDateComponent implements OnInit, OnDestroy {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService,
        private ngDateParserFormatter: NgbDateParserFormatter,
        private router: Router,
        private authenticationService: AuthenticationService) {
    }

    @Input() date;
    mSelectValue: number;
    changeForm: FormGroup;

    routeGroups: RouteGroup[];
    routeGroupOptions: any = [];
    mOptions: any = [];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    is_valid = false;
    isAirLine = false;
    isCarrier = false;   // ← 추가

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {
        const currentUser = this.authenticationService.user.value;
        this.isCarrier = !!currentUser && +currentUser.level === 4;

        this.initForm();
        this.initMonthOptions();

        this.routeGroups = this.routeService.getRouteGroup();
        this.initRouteGroupOptions(this.routeGroups);
        this.routeService.routeGroupsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                (routeGroups: RouteGroup[]) => {
                    this.routeGroups = routeGroups;
                    this.initRouteGroupOptions(routeGroups);
                    this.initMonthOptions();
                }
            );


          this.changeForm.get('isAirLine').valueChanges
              .pipe(takeUntil(this.unsubscribe$))
                .subscribe(
                  (value) => {
                    console.log(value);
                    this.isAirLine = value;
                  }
                );

      // Move to calender
      this.changeForm.get('month').valueChanges
          .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          value => {
            if (value) {
              this.onGotoCalendar(value);
            }
          });
    }

    initForm() {
        this.changeForm = new FormGroup({
            'date': new FormControl(null, Validators.required),
            'month': new FormControl(null),
            'route_group_ids': new FormControl(null, Validators.required),
            'isAirLine': new FormControl(),
        });
    }

    initRouteGroupOptions(routeGroups: RouteGroup[]) {
        if (routeGroups) {
            const routeGroupsTmp = from(routeGroups);
            const example = routeGroupsTmp.pipe(
                groupBy(groups => groups['calendar_group']),
                // return each item in group as array
                mergeMap(group => group.pipe(toArray()))
            );
            const routeGroupsArray = [];
            example.pipe(takeUntil(this.unsubscribe$)).subscribe(
                val => routeGroupsArray.push(val));
            for (const routeGroupsElem of routeGroupsArray) {
                let title = '';
                const routeGroupArrayValue = [];
                for (const routeGroup of routeGroupsElem) {
                    title += routeGroup.title + ' ';
                    routeGroupArrayValue.push(routeGroup.id);
                }
                this.routeGroupOptions.push({'label': title, 'value': routeGroupArrayValue, 'code': title});
            }
        }
    }

    initMonthOptions() {
      const month = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      for (const key in month) {
        this.mOptions.push({'label': month[key], 'value': +key + 1, 'code': key + 1});
      }
    }

    onGotoCalendar(month) {
      const year = new Date().getFullYear();
      this.router.navigate(['/apps/calendars/' + year + '/' + month]);
    }

    checkIsValid() {
        // validators required not working for ng selectize
        const value = this.changeForm.value;
        if (value.date && value.route_group_ids) {
            this.is_valid = true;
        } else {
            this.is_valid = false;
        }
    }


    onSubmit() {
      const value = this.changeForm.value;
      const date = this.ngDateParserFormatter.format(value.date);
      const ids = value.route_group_ids;

        this.router.navigate(['/pages/list-confirmed/', {date: date, routeGroup: ids}]);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
